import Component from 'inferno-component';
import CloseIcon from '../assets/images/close-icon';

function generateEndGameMsg(correct, total) {
  let msg = 'Hulō! Good job, you got';
  if (correct === 1 && total === 1) {
    return msg;
  }
  if (correct <= 1) {
    msg = 'E hoʻāʻo hou (try again)';
  }
  return msg;
}

class FlashCardModal extends Component {
  render() {
    const {
      cards,
      correctCount,
      deckName,
      deckId,
      interactionButtonHideClass,
      markAsCorrect,
      markAsIncorrect,
      revealDefinition,
      revealButtonHideClass,
      selectedDeck,
      skipWord,
      toggleFlashcardModal,
      unusedCards,
      usedCards,
      hideClass,
      playDeck,
    } = this.props;
    return (
      <div className="flashcard-modal">
        <div className="flashcard-modal--container">
          <div className="header">
            <h2>{deckName}</h2>
            <button className="button--invisible" onClick={toggleFlashcardModal}>
              <CloseIcon />
            </button>
          </div>
          {/* CARDS STILL REMAINING IN FLASHCARD GAME*/}
          {unusedCards.length > 0 && (
            <div className="flashcard-modal__guess-word-container">
              <div className="count-and-score">
                <p className="count">
                  {usedCards.length} / {cards.length} words
                </p>
                <p className="score">
                  {correctCount} correct/
                  {usedCards.length - correctCount} incorrect
                </p>
              </div>
              <div>
                <p className="word">{selectedDeck.currentCard.word}</p>
              </div>

              <div className={interactionButtonHideClass}>
                <div className={`reveal-definition ${revealButtonHideClass}`}>
                  <button className="button button--modal" onClick={revealDefinition}>
                    Reveal Definition
                  </button>
                </div>
                <div>
                  {unusedCards.length > 1 && (
                    <button className="button--invisible link link--secondary" onClick={skipWord}>skip &#8250;</button>
                  )}
                </div>
              </div>

              <div
                className={`flashcard-modal__definition-container ${hideClass}`}
              >
                <div className="flashcard-modal__definition-block">
                  {selectedDeck.currentCard.definitions.map(definition => {
                    return (
                      <div className="definition-row__container">
                        <div className="definition-row__gutter">
                          {definition.def_src && (
                            <span className="definition-row__word-src">
                              {definition.def_src}
                            </span>
                          )}
                        </div>
                        <div className="definition-row__body">
                          {definition.ps && (
                            <span className="definition-row__word-class">
                              {definition.ps}
                            </span>
                          )}
                          {definition.props && (
                            <span className="definition-row__word-props">
                              {definition.props}
                            </span>
                          )}
                          {definition.dtxt && (
                            <span className="definition-row__definition">
                              {definition.dtxt}
                            </span>
                          )}
                          {definition.der && (
                            <span className="definition-row__der">
                              {' '}
                              {definition.der}
                            </span>
                          )}
                          <div className="definition-row__example">
                            {definition.extxt && (
                              <span className="definition-row__example-hwn">
                                {definition.extxt}&mdash;
                              </span>
                            )}
                            {definition.extran && (
                              <span className="definition-row__example-eng">
                                {definition.extran}
                              </span>
                            )}
                          </div>
                          {definition.addr &&
                            definition.addr.map(address => {
                              return (
                                <p>
                                  <a href={address._href} target="_blank">
                                    {address.__text}
                                  </a>
                                </p>
                              );
                            })}
                          {definition.notes && (
                            <span className="definition-row__definition">
                              {definition.notes}
                            </span>
                          )}
                          {definition.images &&
                            definition.images.map(imageSrc => {
                              return (
                                <img
                                  className="definition-row__der"
                                  src={imageSrc}
                                  alt="Add word to deck"
                                />
                              );
                            })}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="mark-this">
                  <p>Mark this as</p>
                  <div>
                    <button className="button button--modal" onClick={markAsCorrect}>
                      <span className="correct-icon">&#10003; </span>
                      <span className="correct-text">Correct</span>
                    </button>
                    <button className="button button--modal" onClick={markAsIncorrect}>
                      <span className="incorrect-icon">&#10007; </span>
                      <span className="incorrect-text">Incorrect</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* END OF CARDS STILL REMAINING IN FLASHCARD GAME*/}
          {/* END STATE FOR FLASHCARD GAME*/}
          {unusedCards.length === 0 && (
            <div className="flashcard-modal__final-score-container">
              <div className="text">
                <p>{generateEndGameMsg(correctCount, cards.length)}</p>
              </div>
              <div className="score">
                <p>
                  {correctCount}/{cards.length} Words Correct
                </p>
              </div>
              <div className="words-container">
                {usedCards.map(card => {
                  const correctSymbol = card.markedCorrect ? (
                    <span className="correct-icon">&#10003;</span>
                  ) : (
                    <span className="incorrect-icon">&#10007;</span>
                  );
                  return (
                    <div className="words">
                      {correctSymbol} <span>{card.word}</span>
                    </div>
                  );
                })}
              </div>
              <div className="shuffle-again">
                <form onSubmit={playDeck}>
                  <input type="hidden" value={deckId} name="id" />

                  <button className="button button--modal" type="submit">
                    <p>
                      E kakekake a hoʻomaka hou<br />
                      <span>(Shuffle and Start Again)</span>
                    </p>
                  </button>
                </form>
              </div>
            </div>
          )}
          {/* END OF END STATE FOR FLASHCARD GAME*/}
        </div>
      </div>
    );
  }
}

export default FlashCardModal;



// WEBPACK FOOTER //
// ./src/components/FlashCardModal.js